import { CommentIcon } from "@/assets/images/svgIcons/commentIcon"
import { ThrophIcon } from "@/assets/images/svgIcons/throphIcon"
import { Button } from "@/components/ui/baseUi/button"
import { word } from "@/modules/core/utils/i18n"
import { useScoreCommentFormSidebar } from "@/modules/scores/scoreForms/hooks/useScoreCommentFormSidebar"
import { ScoreType } from "@/modules/scores/scoreTypes"
import type { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import type { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import type { SessionBlockExerciseEntity } from "@/modules/sessions/entities/sessionBlockExerciseEntity"

type ExerciseDetailsScoreCommentButtonProps = {
  parentSession: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity
  exercise: SessionBlockExerciseEntity
}

export function ExerciseDetailsScoreCommentButton({ parentSession, exercise }: ExerciseDetailsScoreCommentButtonProps) {
  const { navigateToCommentForm, navigateToScoreForm } = useScoreCommentFormSidebar(parentSession, exercise)

  return (
    <div className="flex flex-row items-center justify-between gap-1">
      <div className="flex w-full flex-row gap-3">
        {exercise.scoreSetConfigurations.length > 0 &&
        !!exercise.scoreSetConfigurations[0] &&
        ![ScoreType.TEXT_FROM_ATHLETE, ScoreType.NO_SCORE].includes(exercise.scoreSetConfigurations[0].scoreType) ? (
          <Button
            variant={exercise.score?.valueDecimal ? "outline" : "primary"}
            onClick={() => navigateToScoreForm()}
            className="mt-2 w-full"
          >
            <ThrophIcon color="currentColor" className="text-textPrimary" />
            {exercise.score?.valueDecimal
              ? word("exercise.card.button.modify_score")
              : word("exercise.card.button.add_score")}
          </Button>
        ) : (
          <Button
            variant={exercise.score?.note || exercise.score?.medias?.length ? "outline" : "primary"}
            onClick={() => navigateToCommentForm()}
            className="mt-2 w-full"
          >
            <CommentIcon color="currentColor" className="text-textPrimary" height={24} />
            {exercise.score?.note || exercise.score?.medias?.length
              ? word("exercise.card.button.modify_comment")
              : word("exercise.card.button.add_comment")}
          </Button>
        )}
      </div>
    </div>
  )
}
